import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerHelper } from '../../../shared/validators/date-picker-form-validators';
import { Company } from '@models/companies/company';
import { Document } from '@models/documents/document';
import { EntityChangeData } from '@models/documents/entity-change-data';
import { CompanyChangeData } from '@models/ui-models/company-change-data';
import { ChangeDictionaryHelper } from '@models/ui-models/change-dictionary-helper.model';
import { Form410FTransactionComponent } from '../../asic-forms/company/form-410f-transaction/form-410f-transaction.component';
import { PaymentMethod, paymentMethodsNames } from './company-change-name.model';

export enum Form410FStepsEnum {
  FormDetails = 0,
  CompanyNameDetails = 1,
  ExtensionDetails = 2
}

export class Form410FTransaction extends EntityChangeData {
  static override readonly $type = 'Form410FTransaction';

  proposedCompanyName = '';
  reservationDocumentNumber = '';
  existingExpiryDate: Date;
  extensionReason = '';
  paymentMethod: PaymentMethod;

  constructor(data: Partial<Form410FTransaction> = {}) {
    super(data);

    this.changeType = 'c:410f'

    this.proposedCompanyName = data.proposedCompanyName ?? '';
    this.reservationDocumentNumber = data.reservationDocumentNumber ?? '';
    this.existingExpiryDate = DatepickerHelper.toDate(data.existingExpiryDate);
    this.extensionReason = data.extensionReason ?? '';
    this.paymentMethod = data.paymentMethod ?? PaymentMethod.INV;
  }

  override toDictionary(): { key: string; value: string; }[] {
    const dict = new ChangeDictionaryHelper();

    dict
      .add('Proposed new company name', this.proposedCompanyName)
      .add('Name reservation document number', this.reservationDocumentNumber)
      .add('Extension Reason', this.extensionReason)
      .add('Payment Method', paymentMethodsNames[this.paymentMethod])
      .addDate('Date of reservation expiry', this.existingExpiryDate);

    return dict.dictionary;
  }

  fillModal(modalRef: NgbModalRef, document: Document, actualCompany: Company): NgbModalRef {
    modalRef = this.fillModalWithCompany(modalRef, actualCompany, true);
    (modalRef.componentInstance as Form410FTransactionComponent).companyChangeData.documentId = document.documentId;
    return modalRef;
  }

  fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit = false): NgbModalRef {
    const instance = (modalRef.componentInstance as Form410FTransactionComponent);

    instance.isEdit = isEdit;
    instance.companyChangeData = new CompanyChangeData(company);
    instance.formModel = structuredClone(this);

    return modalRef;
  }

  override prepareToRequest(): Form410FTransaction {
    return {
      ...this,
      ...super.prepareToRequest(),
      existingExpiryDate: DatepickerHelper.buildDateString(this.existingExpiryDate),
    };
  }
}
